@let k = data.kitchen;
@if (k) {
  @let gtmPriceDetails = data.gtmConfigPriceDetails;
  @let buttonLabel = "GLOBAL.VIEW_PRICE_DETAILS" | translate;
  <section class="relative max-h-[calc(100svh-50px)] pb-5">
    <div class="mb-5">
      <div #visual class="mask-curve-bottom z-0 h-[410px] max-h-[calc(100svh-200px)] overflow-hidden desk:h-[627px]">
        @if (imageSelected()) {
          <app-image [image]="imageSelected()!" [isPriority]="!isImageInPreviousBlocks" [pregenerationSize]="frame" />
        }
      </div>
      <div
        class="absolute left-1/2 z-10 -mt-8 flex h-[80px] w-[calc(100%-1rem)] -translate-x-1/2 items-center rounded-2xl bg-gray-light desk:-mt-6 desk:h-[86px] desk:w-[483px]">
        @if (this.kitchenVariants(); as kitchenVariants) {
          <div class="grid grid-cols-7 desk:px-2.5">
            @for (variant of kitchenVariants.slice(0, 6); track variant.id) {
              <span (click)="selectVariant(variant.name)" class="flex cursor-pointer flex-col items-center gap-2.5">
                <div
                  [ngClass]="{
                    'outline outline-offset-2 outline-2 outline-black': variantIdSelected() === variant.id,
                  }"
                  class="relative size-[30px] overflow-hidden rounded-[10px] border border-black/25 desk:size-[35px]">
                  @if (variant.colorPreview; as colorPreview) {
                    <app-image
                      [image]="colorPreview"
                      [title]="variant.name"
                      class="block size-full rounded-[10px] object-cover">
                    </app-image>
                  } @else {
                    <div [style.backgroundColor]="`rgb(${variant.colorRgb})`" class="size-full"></div>
                  }
                </div>
                <span [title]="variant.shortName" class="line-clamp-2 text-center text-[10px] leading-none">
                  {{ variant.shortName }}
                </span>
              </span>
            }
            <span class="flex cursor-pointer flex-col items-center gap-2.5">
              <div class="relative size-[30px] overflow-hidden rounded-[10px] border border-black/25 desk:size-[35px]">
                <a [routerLink]="data.finishPageLink" class="flex size-full items-center justify-center bg-anis">
                  <app-svg [height]="19" [width]="19" src="assets/icons/plus.svg" />
                </a>
              </div>
              <a [routerLink]="data.finishPageLink" class="line-clamp-2 text-center text-[10px] leading-none">
                {{ "COMPONENT.HERO-MODELE.ALL_OUR_FINISHES" | translate }}
              </a>
            </span>
          </div>
        }
      </div>
    </div>
    <div class="centered-with-padding mt-16 flex flex-col gap-y-1 desk:mt-10">
      <div
        (click)="
          openPriceDetailsDialog();
          emitGtmEvent({
            event: gtmPriceDetails?.event,
            group: gtmPriceDetails?.group,
            description: gtmPriceDetails?.description,
            context: gtmPriceDetails?.context,
            button_text_value: buttonLabel,
            event_type: 'click',
          })
        "
        [class.pb-4]="!k.ecoPart"
        class="flex cursor-pointer flex-col gap-y-1">
        <div class="flex justify-between">
          <span class="font-title text-[30px] desk:text-[40px]">
            {{ k.name }}
          </span>
          <span class="font-title text-[30px] desk:text-[40px]">{{ k.price }}</span>
        </div>
        @if (k.ecoPart) {
          <div class="flex justify-end">
            <a class="text-end text-[10px]">
              {{ "GLOBAL.INCLUDING_ECO_PART" | translate: { price: k.ecoPart } }}
            </a>
          </div>
        }
      </div>
      <div class="flex flex-col gap-y-0.5">
        <div class="flex justify-between">
          <span>
            @let hasImplantation = k.implantation?.type && k.implantation?.surface;
            @if (hasImplantation) {
              {{
                "COMPONENT.HERO-MODELE.KITCHEN_LAYOUT_WITH_SURFACE"
                  | translate
                    : {
                        type: k.implantation!.type | transformFirstLetter: "lowercase",
                        surface: k.implantation!.surface,
                      }
              }}
            }
          </span>
          <span
            (click)="
              openPriceDetailsDialog();
              emitGtmEvent({
                event: gtmPriceDetails?.event,
                group: gtmPriceDetails?.group,
                description: gtmPriceDetails?.description,
                context: gtmPriceDetails?.context,
                button_text_value: buttonLabel,
                event_type: 'click',
              })
            "
            class="w-[150px] cursor-pointer text-end font-bold desk:w-auto">
            {{ buttonLabel }}
          </span>
        </div>
      </div>
    </div>
  </section>
}
